"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Box_1 = require("../Box");
var base_1 = require("../../themes/base");
var MainHeaderWrapper = styled_components_1.default(Box_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  background: white;\n  min-height: 92px;\n  border-bottom: 1px solid ", ";\n  position: relative;\n"], ["\n  flex-direction: row;\n  align-items: center;\n  background: white;\n  min-height: 92px;\n  border-bottom: 1px solid ", ";\n  position: relative;\n"])), base_1.colors.border.light);
exports.default = MainHeaderWrapper;
var templateObject_1;
//# sourceMappingURL=MainHeaderWrapper.js.map